// extracted by mini-css-extract-plugin
module.exports = {"noResults":"SearchNoResults_noResults__WgEI6","text":"SearchNoResults_text__mxcvF","link":"SearchNoResults_link__Qe_2r"};